import { Component, OnInit, Input, ViewChild, ElementRef } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { BaseComponent } from "../../base.component";
import {
  NgbModal,
  NgbModalOptions,
  ModalDismissReasons,
} from "@ng-bootstrap/ng-bootstrap";
import * as _ from "lodash";
import { SessionManagerService } from "../../_services/SessionManager/session-manager.service";
import { DataService } from "../../_services/data.service";
import { AlertService } from "../../_services/alert.service";

@Component({
  moduleId: module.id,
  selector: "event-meshutaf",
  templateUrl: "event-meshutaf.component.html",
  styleUrls: ["./event-meshutaf.component.css"],
})
export class EventMeshutafComponent extends BaseComponent {
  @Input() event: any;
  modelApprover: any = {};
  modalApproveReference: any;
  loading = false;
  isAllChecked = false;
  approvalMessage: string;
  paymentData: any;

  constructor(
    public dataService: DataService,
    private alertService: AlertService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private modalService: NgbModal,
    public sessionManager: SessionManagerService
  ) {
    super(dataService, sessionManager);
  }

  run() {
    window.scrollTo(0, 0);
  }

  getNest() {
    if (this.event) {
      return {
        nestId: this.event.nestId,
        nestCode: this.event.nestCode,
        nestName: this.event.nestName,
      };
    } else return;
  }

  checkAll() {
    if (
      this.event &&
      this.event.paymentData &&
      this.event.paymentData.length &&
      this.event.paymentData.length > 0
    ) {
      this.event.paymentData.forEach((epd) => {
        epd.checked = this.isAllChecked;
      });
    }
  }

  commit(modalContent) {
    this.paymentData = { payments: [], total: 0 };
    if (
      this.event &&
      this.event.paymentData &&
      this.event.paymentData.length &&
      this.event.paymentData.length > 0
    ) {
      this.event.paymentData.forEach((epd) => {
        if (epd.active && epd.checked) {
          this.paymentData.payments.push(epd);
          this.paymentData.total =
            parseFloat(epd.finalPrice) + this.paymentData.total;
        }
      });
    }

    if (
      this.paymentData.payments.length &&
      this.paymentData.payments.length > 0 &&
      this.base.messages["admin_meshutaf_approve_popup"]
    ) {
      this.approvalMessage = this.base.messages["admin_meshutaf_approve_popup"]
        .replace("$1$", this.event.eventName)
        .replace("$2$", this.paymentData.total)
        .replace("$3$", this.paymentData.payments.length);

      let options: NgbModalOptions = {
        windowClass: "approve-modal",
        backdrop: "static",
      };
      this.modalApproveReference = this.modalService.open(
        modalContent,
        options
      );
    }
  }

  requestRefund(item) {
    if (!this.loading == true) {
      this.loading = true;
      item["eventId"] = this.event["eventId"];
      item["eventDate"] = this.event["eventDate"];
      this.dataService.refund(item, false, false).subscribe(
        (data) => {
          if (data && data.allowRequest) {
            localStorage.setItem("refundItem", JSON.stringify(item));
            this.router.navigate(["/refund"]);
          } else {
            location.reload();
          }
        },
        (error) => {
          let body = error.json && error.json();
          this.alertService.error(
            body && body.statusText
              ? this.base.messages[body.statusText]
                ? this.base.messages[body.statusText]
                : decodeURIComponent(body.statusText)
              : (error && error.statusText) || error
          );
          this.loading = false;
        }
      );
    }
  }

  redirectToRefundRequest(item) {
    localStorage.setItem("refundItem", JSON.stringify(item));
    this.router.navigate(["/refund"]);
  }

  meshutafSuccess() {
    this.modalApproveReference.close();
    location.reload();
  }

  refundHappenedEvent() {
    location.reload();
  }

  getItemForRefund(item) {
    item["eventId"] = this.event["eventId"];
    item["eventDate"] = this.event["eventDate"];
    return item;
  }

  approve(modalContent) {
    if (!this.loading) {
      let postData = _.merge(this.paymentData, this.modelApprover, {
        event: this.event,
      });

      this.loading = true;
      this.dataService.approveEventMeshutaf(postData).subscribe(
        (data) => {
          this.loading = false;
          //                  	this.model = {};
          //         this.alertService.success('ההתחייבות הופקה בהצלחה', true);

          // 					if (data && data.fileUrl)
          // 					  window.open(data.fileUrl);
          this.modalApproveReference.close();
          let options: NgbModalOptions = {
            windowClass: "approve-modal",
            backdrop: "static",
          };
          this.modalApproveReference = this.modalService.open(
            modalContent,
            options
          );

          // 				this.router.navigate(['/']);
        },
        (error) => {
          this.loading = false;
          if (error && error.json() && error.json().statusText) {
            if (
              typeof this.base.messages[error.json().statusText] !== "undefined"
            )
              this.alertService.error(
                this.base.messages[error.json().statusText]
              );
            else
              this.alertService.error(
                decodeURIComponent(error.json().statusText)
              );
          } else
            this.alertService.error(
              error && error.statusText
                ? decodeURIComponent(error.statusText)
                : error
            );
        }
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/meshutaf/event-meshutaf.component.ts